import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { Vector3 } from 'three'


// Debug
const gui = new dat.GUI( { width: 150 })
gui.close()
const debugObject = {}

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()

const concreteBaseColorTexture = textureLoader.load('/textures/walls/concreteBaseColor.jpg')
const concreteAmbientOcclusionTexture = textureLoader.load('/textures/walls/concreteAmbientOcclusion.jpg')
const concreteNormalTexture = textureLoader.load('/textures/walls/concreteNormal.jpg')
const concreteRoughnessTexture = textureLoader.load('/textures/walls/concreteRoughness.jpg')
const concreteHeightTexture = textureLoader.load('/textures/walls/concreteHeight.jpg')


const grassColorTexture = textureLoader.load('/textures/grass/color.jpg')
const grassAmbientOcclusionTexture = textureLoader.load('/textures/grass/ambientOcclusion.jpg')
const grassNormalTexture = textureLoader.load('/textures/grass/normal.jpg')
const grassRoughnessTexture = textureLoader.load('/textures/grass/roughness.jpg')


grassColorTexture.repeat.set(8, 8)
grassAmbientOcclusionTexture.repeat.set(8, 8)
grassNormalTexture.repeat.set(8, 8)
grassRoughnessTexture.repeat.set(8, 8)

grassColorTexture.wrapS = THREE.RepeatWrapping
grassAmbientOcclusionTexture.wrapS = THREE.RepeatWrapping
grassNormalTexture.wrapS = THREE.RepeatWrapping
grassRoughnessTexture.wrapS = THREE.RepeatWrapping

grassColorTexture.wrapT = THREE.RepeatWrapping
grassAmbientOcclusionTexture.wrapT = THREE.RepeatWrapping
grassNormalTexture.wrapT = THREE.RepeatWrapping
grassRoughnessTexture.wrapT = THREE.RepeatWrapping

// Floor
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(200, 200),
    new THREE.MeshStandardMaterial({
        map: grassColorTexture,
        aoMap: grassAmbientOcclusionTexture,
        normalMap: grassNormalTexture,
        roughnessMap: grassRoughnessTexture
    })
)
floor.geometry.setAttribute('uv2', new THREE.Float32BufferAttribute(floor.geometry.attributes.uv.array, 2))
floor.rotation.x = - Math.PI * 0.5
floor.position.y = 0
scene.add(floor)

// Walls
let board = new Array (20)
for (var i = 0; i < 20; i++) {
    board[i] = new Array (20)
}

for (var r = 0; r < 20; r++) {
    for (var c = 0; c < 20; c++) {
        board[r][c] = null
    }
}

console.log(board);
// Material
const material = new THREE.MeshStandardMaterial({
    map: concreteBaseColorTexture,
    aoMap: concreteAmbientOcclusionTexture,
    normalMap: concreteNormalTexture,
    roughnessMap: concreteRoughnessTexture,
    displacementMap: concreteHeightTexture,
    displacementScale: 1
}
)

const wall1 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall1.translateY(10)
wall1.translateZ(4.5)
wall1.translateX(85)
board[19][9] = 0
scene.add(wall1)

const wall2 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall2.translateY(10)
wall2.translateZ(-14.5)
wall2.translateX(85)
board[18][9] = 0
scene.add(wall2)

const wall3 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall3.translateY(10)
wall3.translateZ(4.5)
wall3.translateX(75)
board[19][11] = 0
scene.add(wall3)

const wall4 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall4.translateY(10)
wall4.translateZ(-14.5)
wall4.translateX(75)
board[18][11] = 0
scene.add(wall4)

const wall5 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall5.translateY(10)
wall5.translateZ(25)
wall5.translateX(74.5)
board[18][6] = 0
scene.add(wall5)

const wall6 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall6.translateY(10)
wall6.translateZ(15)
wall6.translateX(74.5)
board[18][7] = 0
scene.add(wall6)

const wall7 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall7.translateY(10)
wall7.translateZ(35)
wall7.translateX(74.5)
board[18][8] = 0
scene.add(wall7)

const wall8 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall8.translateY(10)
wall8.translateZ(-55)
wall8.translateX(74.5)
board[18][15] = 0
scene.add(wall8)

const wall9 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall9.translateY(10)
wall9.translateZ(-75)
wall9.translateX(74.5)
board[18][17] = 0
scene.add(wall9)

const wall10 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall10.translateY(10)
wall10.translateZ(75)
wall10.translateX(64.5)
board[17][2] = 0
scene.add(wall10)

const wall11 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall11.translateY(10)
wall11.translateZ(55)
wall11.translateX(64.5)
board[17][4] = 0
scene.add(wall11)

const wall12 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall12.translateY(10)
wall12.translateZ(-35)
wall12.translateX(64.5)
board[17][13] = 0
scene.add(wall12)

const wall13 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall13.translateY(10)
wall13.translateZ(-75)
wall13.translateX(64.5)
board[17][17] = 0
scene.add(wall13)

const wall14 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall14.translateY(10)
wall14.translateZ(25)
wall14.translateX(54.5)
board[16][7] = 0
scene.add(wall14)

const wall15 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall15.translateY(10)
wall15.translateZ(14.5)
wall15.translateX(55)
board[16][8] = 0
scene.add(wall15)

const wall16 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall16.translateY(10)
wall16.translateZ(-5)
wall16.translateX(54.5)
board[16][10] = 0
scene.add(wall16)

const wall17 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall17.translateY(10)
wall17.translateZ(-15)
wall17.translateX(54.5)
board[16][11] = 0
scene.add(wall17)

const wall18 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall18.translateY(10)
wall18.translateZ(-25)
wall18.translateX(54.5)
board[16][12] = 0
scene.add(wall18)

const wall19 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall19.translateY(10)
wall19.translateZ(-35)
wall19.translateX(54.5)
board[16][13] = 0
scene.add(wall19)

const wall20 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall20.translateY(10)
wall20.translateZ(-55)
wall20.translateX(54.5)
board[16][15] = 0
scene.add(wall20)

const wall21 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall21.translateY(10)
wall21.translateZ(55)
wall21.translateX(44.5)
board[15][4] = 0
scene.add(wall21)

const wall22 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall22.translateY(10)
wall22.translateZ(45)
wall22.translateX(44.5)
board[15][5] = 0
scene.add(wall22)

const wall23 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall23.translateY(10)
wall23.translateZ(-65)
wall23.translateX(44.5)
board[15][16] = 0
scene.add(wall23)

const wall24 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall24.translateY(10)
wall24.translateZ(64.5)
wall24.translateX(35)
board[14][3] = 0
scene.add(wall24)

const wall25 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall25.translateY(10)
wall25.translateZ(55)
wall25.translateX(34.5)
board[14][4] = 0
scene.add(wall25)

const wall26 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall26.translateY(10)
wall26.translateZ(45)
wall26.translateX(34.5)
board[14][5] = 0
scene.add(wall26)

const wall27 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall27.translateY(10)
wall27.translateZ(35)
wall27.translateX(34.5)
board[14][6] = 0
scene.add(wall27)

const wall28 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall28.translateY(10)
wall28.translateZ(24.5)
wall28.translateX(35)
board[14][7] = 0
scene.add(wall28)

const wall29 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall29.translateY(10)
wall29.translateZ(-4.5)
wall29.translateX(35)
board[14][10] = 0
scene.add(wall29)

const wall30 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall30.translateY(10)
wall30.translateZ(-25)
wall30.translateX(34.5)
board[14][12] = 0
scene.add(wall30)

const wall31 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall31.translateY(10)
wall31.translateZ(-35)
wall31.translateX(34.5)
board[14][13] = 0
scene.add(wall31)

const wall32 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall32.translateY(10)
wall32.translateZ(-45)
wall32.translateX(34.5)
board[14][14] = 0
scene.add(wall32)

const wall33 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall33.translateY(10)
wall33.translateZ(64.5)
wall33.translateX(25)
board[13][3] = 0
scene.add(wall33)

const wall34 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall34.translateY(10)
wall34.translateZ(24.5)
wall34.translateX(25)
board[13][7] = 0
scene.add(wall34)

const wall35 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall35.translateY(10)
wall35.translateZ(15)
wall35.translateX(24.5)
board[13][8] = 0
scene.add(wall35)

const wall36 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall36.translateY(10)
wall36.translateZ(-4.5)
wall36.translateX(25)
board[13][10] = 0
scene.add(wall36)

const wall37 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall37.translateY(10)
wall37.translateZ(-24.5)
wall37.translateX(25)
board[13][12] = 0
scene.add(wall37)

const wall38 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall38.translateY(10)
wall38.translateZ(-35)
wall38.translateX(24.5)
board[13][13] = 0
scene.add(wall38)

const wall39 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall39.translateY(10)
wall39.translateZ(-45)
wall39.translateX(24.5)
board[13][14] = 0
scene.add(wall39)

const wall40 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall40.translateY(10)
wall40.translateZ(-64.5)
wall40.translateX(25)
board[13][16] = 0
scene.add(wall40)

const wall44 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall44.translateY(10)
wall44.translateZ(64.5)
wall44.translateX(15)
board[12][3] = 0
scene.add(wall44)

const wall45 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall45.translateY(10)
wall45.translateZ(44.5)
wall45.translateX(15)
board[12][5] = 0
scene.add(wall45)

const wall46 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall46.translateY(10)
wall46.translateZ(24.5)
wall46.translateX(15)
board[12][7] = 0
scene.add(wall46)

const wall47 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall47.translateY(10)
wall47.translateZ(15)
wall47.translateX(14.5)
board[12][8] = 0
scene.add(wall47)

const wall48 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall48.translateY(10)
wall48.translateZ(-4.5)
wall48.translateX(15)
board[12][10] = 0
scene.add(wall48)

const wall49 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall49.translateY(10)
wall49.translateZ(-24.5)
wall49.translateX(15)
board[12][12] = 0
scene.add(wall49)

const wall50 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall50.translateY(10)
wall50.translateZ(-34.5)
wall50.translateX(15)
board[12][13] = 0
scene.add(wall50)

const wall51 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall51.translateY(10)
wall51.translateZ(-64.5)
wall51.translateX(15)
board[12][16] = 0
scene.add(wall51)

const wall52 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall52.translateY(10)
wall52.translateZ(64.5)
wall52.translateX(5)
board[11][3] = 0
scene.add(wall52)

const wall53 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall53.translateY(10)
wall53.translateZ(44.5)
wall53.translateX(5)
board[11][5] = 0
scene.add(wall53)

const wall55 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall55.translateY(10)
wall55.translateZ(24.5)
wall55.translateX(5)
board[11][7] = 0
scene.add(wall55)

const wall56 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall56.translateY(10)
wall56.translateZ(15)
wall56.translateX(4.5)
board[11][8] = 0
scene.add(wall56)

const wall57 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall57.translateY(10)
wall57.translateZ(5)
wall57.translateX(4.5)
board[11][9] = 0
scene.add(wall57)

const wall58 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall58.translateY(10)
wall58.translateZ(-5)
wall58.translateX(4.5)
board[11][10] = 0
scene.add(wall58)

const wall59 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall59.translateY(10)
wall59.translateZ(-24.5)
wall59.translateX(5)
board[11][12] = 0
scene.add(wall59)

const wall60 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall60.translateY(10)
wall60.translateZ(-55)
wall60.translateX(4.5)
board[11][15] = 0
scene.add(wall60)

const wall61 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall61.translateY(10)
wall61.translateZ(-64.5)
wall61.translateX(5)
board[11][16] = 0
scene.add(wall61)

const wall62 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall62.translateY(10)
wall62.translateZ(64.5)
wall62.translateX(-5)
board[10][3] = 0
scene.add(wall62)

const wall63 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall63.translateY(10)
wall63.translateZ(44.5)
wall63.translateX(-5)
board[10][5] = 0
scene.add(wall63)

const wall64 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall64.translateY(10)
wall64.translateZ(-34.5)
wall64.translateX(-5)
board[10][13] = 0
scene.add(wall64)

const wall65 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall65.translateY(10)
wall65.translateZ(-55)
wall65.translateX(-4.5)
board[10][15] = 0
scene.add(wall65)

const wall66 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall66.translateY(10)
wall66.translateZ(64.5)
wall66.translateX(-15)
board[9][3] = 0
scene.add(wall66)

const wall67 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall67.translateY(10)
wall67.translateZ(44.5)
wall67.translateX(-15)
board[9][5] = 0
scene.add(wall67)

const wall68 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall68.translateY(10)
wall68.translateZ(35)
wall68.translateX(-14.5)
board[9][6] = 0
scene.add(wall68)

const wall69 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall69.translateY(10)
wall69.translateZ(25)
wall69.translateX(-14.5)
board[9][7] = 0
scene.add(wall69)

const wall70 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall70.translateY(10)
wall70.translateZ(-15)
wall70.translateX(-14.5)
board[9][11] = 0
scene.add(wall70)

const wall71 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall71.translateY(10)
wall71.translateZ(-34.5)
wall71.translateX(-15)
board[9][13] = 0
scene.add(wall71)

const wall72 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall72.translateY(10)
wall72.translateZ(-75)
wall72.translateX(-14.5)
board[9][17] = 0
scene.add(wall72)

const wall73 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall73.translateY(10)
wall73.translateZ(64.5)
wall73.translateX(-25)
board[8][3] = 0
scene.add(wall73)

const wall74 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall74.translateY(10)
wall74.translateZ(5)
wall74.translateX(-24.5)
board[8][9] = 0
scene.add(wall74)

const wall75 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall75.translateY(10)
wall75.translateZ(-45)
wall75.translateX(-24.5)
board[8][14] = 0
scene.add(wall75)

const wall76 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall76.translateY(10)
wall76.translateZ(-55)
wall76.translateX(-24.5)
board[8][15] = 0
scene.add(wall76)

const wall77 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall77.translateY(10)
wall77.translateZ(64.5)
wall77.translateX(-35)
board[7][3] = 0
scene.add(wall77)

const wall78 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall78.translateY(10)
wall78.translateZ(45)
wall78.translateX(-34.5)
board[7][5] = 0
scene.add(wall78)

const wall79 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall79.translateY(10)
wall79.translateZ(35)
wall79.translateX(-34.5)
board[7][6] = 0
scene.add(wall79)

const wall80 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall80.translateY(10)
wall80.translateZ(25)
wall80.translateX(-34.5)
board[7][7] = 0
scene.add(wall80)

const wall81 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall81.translateY(10)
wall81.translateZ(15)
wall81.translateX(-34.5)
board[7][8] = 0
scene.add(wall81)

const wall82 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall82.translateY(10)
wall82.translateZ(-5)
wall82.translateX(-34.5)
board[7][10] = 0
scene.add(wall82)

const wall83 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall83.translateY(10)
wall83.translateZ(-15)
wall83.translateX(-34.5)
board[7][11] = 0
scene.add(wall83)

const wall84 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall84.translateY(10)
wall84.translateZ(-25)
wall84.translateX(-34.5)
board[7][12] = 0
scene.add(wall84)

const wall85 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall85.translateY(10)
wall85.translateZ(-75)
wall85.translateX(-34.5)
board[7][17] = 0
scene.add(wall85)

const wall86 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall86.translateY(10)
wall86.translateZ(64.5)
wall86.translateX(-45)
board[6][3] = 0
scene.add(wall86)

const wall87 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall87.translateY(10)
wall87.translateZ(-45)
wall87.translateX(-44.5)
board[6][13] = 0
scene.add(wall87)

const wall88 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall88.translateY(10)
wall88.translateZ(-55)
wall88.translateX(-44.5)
board[6][15] = 0
scene.add(wall88)

const wall89 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall89.translateY(10)
wall89.translateZ(54.5)
wall89.translateX(-55)
board[5][4] = 0
scene.add(wall89)

const wall90 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall90.translateY(10)
wall90.translateZ(45)
wall90.translateX(-54.5)
board[5][5] = 0
scene.add(wall90)

const wall91 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall91.translateY(10)
wall91.translateZ(35)
wall91.translateX(-54.5)
board[5][6] = 0
scene.add(wall91)

const wall92 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall92.translateY(10)
wall92.translateZ(25)
wall92.translateX(-54.5)
board[5][7] = 0
scene.add(wall92)

const wall93 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall93.translateY(10)
wall93.translateZ(15)
wall93.translateX(-54.5)
board[5][8] = 0
scene.add(wall93)

const wall94 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall94.translateY(10)
wall94.translateZ(5)
wall94.translateX(-54.5)
board[5][9] = 0
scene.add(wall94)

const wall95 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall95.translateY(10)
wall95.translateZ(-5)
wall95.translateX(-54.5)
board[5][10] = 0
scene.add(wall95)

const wall96 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall96.translateY(10)
wall96.translateZ(-15)
wall96.translateX(-54.5)
board[5][11] = 0
scene.add(wall96)

const wall97 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall97.translateY(10)
wall97.translateZ(-34.5)
wall97.translateX(-55)
board[5][13] = 0
scene.add(wall97)

const wall98 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall98.translateY(10)
wall98.translateZ(-45)
wall98.translateX(-54.5)
board[5][14] = 0
scene.add(wall98)

const wall99 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall99.translateY(10)
wall99.translateZ(64.5)
wall99.translateX(-65)
board[4][3] = 0
scene.add(wall99)

const wall100 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall100.translateY(10)
wall100.translateZ(54.5)
wall100.translateX(-65)
board[4][4] = 0
scene.add(wall100)

const wall101 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall101.translateY(10)
wall101.translateZ(-35)
wall101.translateX(-64.5)
board[4][13] = 0
scene.add(wall101)

const wall102 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall102.translateY(10)
wall102.translateZ(-45)
wall102.translateX(-64.5)
board[4][14] = 0
scene.add(wall102)

const wall103 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall103.translateY(10)
wall103.translateZ(-55)
wall103.translateX(-64.5)
board[4][15] = 0
scene.add(wall103)

const wall104 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall104.translateY(10)
wall104.translateZ(-65)
wall104.translateX(-64.5)
board[4][16] = 0
scene.add(wall104)

const wall105 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall105.translateY(10)
wall105.translateZ(-75)
wall105.translateX(-64.5)
board[4][17] = 0
scene.add(wall105)

const wall106 = new THREE.Mesh(
    new THREE.BoxGeometry(10, 20, 1),
    material
)
wall106.translateY(10)
wall106.translateZ(54.5)
wall106.translateX(-75)
board[3][4] = 0
scene.add(wall106)

const wall107 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall107.translateY(10)
wall107.translateZ(35)
wall107.translateX(-74.5)
board[3][6] = 0
scene.add(wall107)

const wall108 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall108.translateY(10)
wall108.translateZ(25)
wall108.translateX(-74.5)
board[3][7] = 0
scene.add(wall108)

const wall109 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall109.translateY(10)
wall109.translateZ(15)
wall109.translateX(-74.5)
board[3][8] = 0
scene.add(wall109)

const wall110 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall110.translateY(10)
wall110.translateZ(5)
wall110.translateX(-74.5)
board[3][9] = 0
scene.add(wall110)

const wall111 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall111.translateY(10)
wall111.translateZ(-5)
wall111.translateX(-74.5)
board[3][10] = 0
scene.add(wall111)

const wall112 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall112.translateY(10)
wall112.translateZ(-15)
wall112.translateX(-74.5)
board[3][11] = 0
scene.add(wall112)

const wall113 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 20, 10),
    material
)
wall113.translateY(10)
wall113.translateZ(-75)
wall113.translateX(-74.5)
board[3][17] = 0
scene.add(wall113)

for (let r = 0; r < 2; r++)
{
    for(let c = 0; c < 20; c ++)
    {
        const wall114 = new THREE.Mesh(
            new THREE.BoxGeometry(10, 20, 1),
            material
        )
        wall114.translateY(10)
        wall114.translateZ(94.5-(10*r))
        wall114.translateX(95-(10*c))
        board[r][c] = 0
        scene.add(wall114)
    }
}

for (let r = 0; r < 2; r++)
{
    for(let c = 0; c < 20; c ++)
    {
        const wall115 = new THREE.Mesh(
            new THREE.BoxGeometry(10, 20, 1),
            material
        )
        wall115.translateY(10)
        wall115.translateZ(-94.5+(10*r))
        wall115.translateX(95-(10*c))
        board[r][c] = 0
        scene.add(wall115)
    }
}

for (let r = 0; r < 16; r++)
{
    for(let c = 0; c < 2; c ++)
    {
        if(!(c==1 && (r==7 || r==8 || r==9)))
        {
            const wall116 = new THREE.Mesh(
                new THREE.BoxGeometry(1, 20, 10),
                material
            )
            wall116.translateY(10)
            wall116.translateZ(75-(10*r))
            wall116.translateX(94.5-(10*c))
            board[r][c] = 0
            scene.add(wall116)
        }
    }
}

for (let r = 0; r < 16; r++)
{
    for(let c = 0; c < 2; c ++)
    {
        if(!((c==0 || c==1 ) && (r==3)))
        {
            const wall117 = new THREE.Mesh(
                new THREE.BoxGeometry(1, 20, 10),
                material
            )
            wall117.translateY(10)
            wall117.translateZ(75-(10*r))
            wall117.translateX(-94.5+(10*c))
            board[r][c] = 0
            scene.add(wall117)
        }
    }
}

board[1][5] = null


// Lights
const ambientLight = new THREE.AmbientLight('#38363f', 0.2)
scene.add(ambientLight)

const hemisphereLight = new THREE.HemisphereLight('#079217', '#38363f', 0.5)
scene.add(hemisphereLight)

const pointLight1 = new THREE.PointLight('#DCE311', 1, 100)
scene.add(pointLight1)

const pointLight2 = new THREE.PointLight('#DCE311', 1, 100)
scene.add(pointLight2)



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.01, 500)
camera.position.x = 85
camera.position.y = 5
camera.position.z = -5
camera.lookAt(new THREE.Vector3(-85, 5, -5))
scene.add(camera)

const listener = new THREE.AudioListener();
    camera.add( listener );
    const sound = new THREE.Audio( listener );
    const audioLoader = new THREE.AudioLoader();
    audioLoader.load( 'sounds/rain.wav', function( buffer ) {
        sound.setBuffer( buffer );
        sound.setLoop( true );
        sound.setVolume( 0.75 );
        sound.play()
        
    });


// Game Controls

let direcFace = 1
// 1 - Forward
// 2 - Back
// 3 - Right
// 4 - Left

// Starting Positon: [19][10]
let camRow = 19
let camCol = 10

let inAnimateRight = false
let inAnimateLeft = false
let inAnimateBack = false
let inAnimateFront = false

// Move Right
const MoveRight = () => {
    if(!inMotion)
    {
        if (direcFace == 1)
        {
            if(board[camRow][camCol + 1] == null)
            {
                inAnimateRight = true
                camCol = camCol + 1
            }
        }
        else if (direcFace == 2)
        {
            if(board[camRow][camCol - 1] == null)
            {
                inAnimateRight = true
                camCol = camCol - 1
            }
        }
        else if (direcFace == 3)
        {
            if(board[camRow + 1][camCol] == null)
            {
                inAnimateRight = true
                camRow = camRow + 1
            }
        }
        else
        {
            if(board[camRow - 1][camCol] == null)
            {
                inAnimateRight = true
                camRow = camRow - 1
            }
        }
    }
}

debugObject.MoveRight = () => {
    MoveRight()
}
gui.add(debugObject, 'MoveRight').name('Move Right!')

// Move Left
const MoveLeft = () => {
    if(!inMotion)
    {
        if (direcFace == 1)
        {
            if(board[camRow][camCol - 1] == null)
            {
                inAnimateLeft = true
                camCol = camCol - 1
            }
        }
        else if (direcFace == 2)
        {
            if(board[camRow][camCol + 1] == null)
            {
                inAnimateLeft = true
                camCol = camCol + 1
            }
        }
        else if (direcFace == 3)
        {
            if(board[camRow - 1][camCol] == null)
            {
                inAnimateLeft = true
                camRow = camRow - 1
            }
        }
        else
        {
            if(board[camRow + 1][camCol] == null)
            {
                inAnimateLeft = true
                camRow = camRow + 1
            }
        }
    }
}

debugObject.MoveLeft = () => {
    MoveLeft()
}
gui.add(debugObject, 'MoveLeft').name('Move Left!')

// Move Front
const MoveFront = () => {
    if(!inMotion)
    {
        if (direcFace == 1)
        {
            if(board[camRow - 1][camCol] == null)
            {
                inAnimateFront = true
                camRow = camRow - 1
            }
        }
        else if (direcFace == 2)
        {
            if(board[camRow + 1][camCol] == null)
            {
                inAnimateFront = true
                camRow = camRow + 1
            }
        }
        else if (direcFace == 3)
        {
            if(board[camRow][camCol + 1] == null)
            {
                inAnimateFront = true
                camCol = camCol + 1
            }
        }
        else
        {
            if(board[camRow][camCol - 1] == null)
            {
                inAnimateFront = true
                camCol = camCol - 1
            }
        }
    }
}

debugObject.MoveFront = () => {
    MoveFront()
}
gui.add(debugObject, 'MoveFront').name('Move Forward!')

// Move Back
const MoveBack = () => {
    if(!inMotion)
    {
        if (direcFace == 1)
        {
            inAnimateBack = true
            direcFace = 2
        }
        else if (direcFace == 2)
        {
            inAnimateBack = true
            direcFace = 1
        }
        else if (direcFace == 3)
        {
            inAnimateBack = true
            direcFace = 4
        }
        else
        {
            inAnimateBack = true
            direcFace = 3
        }
    }
}

debugObject.MoveBack = () => {
    MoveBack()
}
gui.add(debugObject, 'MoveBack').name('Turn Around!')



/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
//renderer.setClearColor('#262837')





/**
 * Animate
 */
const clock = new THREE.Clock()
let tickCounter = 0
let inMotion = false
const tick = () =>
{
    if(inAnimateRight == true)
    {
        inMotion = true
        if(tickCounter < 90)
        {
            if (direcFace == 1)
            {
                camera.position.z -= 10/90
            }
            else if (direcFace == 2)
            {
                camera.position.z += 10/90
            }
            else if (direcFace == 3)
            {
                camera.position.x += 10/90
            }
            else
            {
                camera.position.x -= 10/90
            }
            camera.rotateY(- Math.PI / 180)
            tickCounter = tickCounter+1
        }
        else
        {
            if (direcFace == 1)
            {
                direcFace = 3
            }
            else if (direcFace == 2)
            {
                direcFace = 4
            }
            else if (direcFace == 3)
            {
                direcFace = 2
            }
            else
            {
                direcFace = 1
            }
            inAnimateRight = false
            console.log(camera.position);
            console.log(camRow + "  " + camCol);
            tickCounter = 0
            inMotion = false
        }
    }
    else if(inAnimateLeft == true)
    {
        inMotion = true
        if(tickCounter < 90)
        {
            if (direcFace == 1)
            {
                camera.position.z += 10/90
            }
            else if (direcFace == 2)
            {
                camera.position.z -= 10/90
            }
            else if (direcFace == 3)
            {
                camera.position.x -= 10/90
            }
            else
            {
                camera.position.x += 10/90
            }
            camera.rotateY(Math.PI / 180)
            tickCounter = tickCounter+1
        }
        else
        {
            if (direcFace == 1)
            {
                direcFace = 4
            }
            else if (direcFace == 2)
            {
                direcFace = 3
            }
            else if (direcFace == 3)
            {
                direcFace = 1
            }
            else
            {
                direcFace = 2
            }
            inAnimateLeft = false
            console.log(camera.position);
            console.log(camRow + "  " + camCol);
            tickCounter = 0
            inMotion = false
        }
    }

    else if(inAnimateFront == true)
    {
        inMotion = true
        if(tickCounter < 90)
        {
            if (direcFace == 1)
            {
                camera.position.x -= 10/90
            }
            else if (direcFace == 2)
            {
                camera.position.x += 10/90
            }
            else if (direcFace == 3)
            {
                camera.position.z -= 10/90
            }
            else
            {
                camera.position.z += 10/90
            }
            tickCounter = tickCounter+1
        }
        else
        {
            inAnimateFront = false
            console.log(camera.position);
            console.log(camRow + "  " + camCol);
            tickCounter = 0
            inMotion = false
        }
    }

    else if(inAnimateBack == true)
    {
        inMotion = true
        if(tickCounter < 90)
        {
            if (direcFace == 1)
            {
                camera.position.x += 5
                inAnimateBack = true
                direcFace = 2
            }
            else if (direcFace == 2)
            {
                camera.position.x -= 5
                inAnimateBack = true
                direcFace = 1
            }
            else if (direcFace == 3)
            {
                camera.position.z += 5
                inAnimateBack = true
                direcFace = 4
            }
            else
            {
                camera.position.z -= 5
                inAnimateBack = true
                direcFace = 3
            }
            camera.rotateY(Math.PI / 90)
            tickCounter = tickCounter+1
        }
        else
        {
            inAnimateBack = false
            console.log(camera.position);
            console.log(camRow + "  " + camCol);
            tickCounter = 0
            inMotion = false
        }
    }

    if(camRow == 1 && camCol == 5)
    {
        camera.position.x = 0
        camera.position.y = 200
        camera.position.z = 0
        camera.lookAt(new Vector3())
    }

    // Point Light
    const elapsedTime = clock.getElapsedTime()
    const angle = elapsedTime * 0.5

    pointLight1.position.x = Math.cos(angle) * 100
    pointLight1.position.z = Math.sin(angle) * 100

    pointLight2.position.x = Math.cos(angle) * - 50
    pointLight2.position.z = Math.sin(angle) * - 50


    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()